import React, { useEffect, useState } from 'react'
import ErrorMessage from '../../../../../../../UI/messages/ErrorMessage'
import MyButton from '../../../../../../../UI/form/MyButton'
import { checkValid, setValueForm, updateValidate } from '../../../../../../../../helpers/form/FormHelper'
import { formDataProductIsField, formDataProductRequiredField } from '../../../../../../../../helpers/form/FormData'
import SupplierUsersSelectMain from '../../../../../../../form/fields/SupplierUsersSelectMain'
import { createNewSupplyOrderFromOrderAPI } from '../../../../../../../../api/supply/supplyOrderAPI'
import { responseError } from '../../../../../../../../helpers/response/ResponseHelper'
import SuccessMessage from '../../../../../../../UI/messages/SuccessMessage'
import { useDispatch } from 'react-redux'
import { editSupplyOrderItems } from '../../../../../../../../store/supplyOrderSlice'

const CreateNewSupplyOrderForm = ({ checked, supplyOrderId, setChecked, setOpen }) => {

    // console.log('checked', checked)

    const dispatch = useDispatch()

    // const [data, setData] = useState(supplierBd ? supplierBd : {}) // Дані з форми
    const [data, setData] = useState({}) // Дані з форми

    const [valid, setValid] = useState({}) // Валідація кожного поля
    const [loading, setLoading] = useState(false)

    const [isValidForm, setIsValidForm] = useState(false) // Загальна валідація форми
    const [result, setResult] = useState('')
    const [error, setError] = useState('')

    useEffect(() => {
        checkValid(valid, setIsValidForm)
    }, [valid])

    const create = (e) => {
        e.preventDefault()
        // const dataForBd = setDataForBd()

        // console.log('dataForBd', dataForBd)

        setError('')
        setLoading(true)
        
        createNewSupplyOrderFromOrderAPI({ 
            supplyOrderId, itemsChecked: checked,
            userId: data.userId
        }).then(data => {
            if (data && data.supplyOrderOld) {
                dispatch(editSupplyOrderItems(data.supplyOrderOld.items))
                if (setChecked) {
                    setChecked({})
                }
            }
            
            setResult(data.supplyOrderNew)
            setLoading(true)
        }).catch (e => {
            setError(responseError(e))
            setLoading(true)
        })
    }

  return (
    <div className='myFormSimple'>
        <p>
            При створенні нової заявки будуть винесені обрані позиції. <br />
            Оберіть <b>відповідального за нову заявку</b> та підтвердіть дію <br />
            Будьте уважні, повернути цю дію буде неможливо!
        </p>

        {
			formDataProductIsField('userId', 'supplyOrderCreateNew') ?
				<SupplierUsersSelectMain
					required={formDataProductRequiredField('userId', 'supplyOrderCreateNew')}
					setValidate={e => updateValidate(setValid, 'userId', e)}
					setValueForm={e => setValueForm(setData, 'userId', e)}
					forciblyValue={data && data.userId ? data.userId : ''}
				/>
			: ''
        }

        <ErrorMessage
            error={error}
        />

        {
            result ?
                <SuccessMessage
                    success={
                        <div>
                            Створено нову заявку з ID {result.id}<br />
                            <a href={`/supply/orders/${result.id}`} target='_blank'>Відкрити заявку в новому вікні</a>
                        </div>
                    }
                />
            : ''
        }

        <MyButton
            size='md'
            onClick={create}
            disabled={!isValidForm || loading ? true : false}
        >
            Зберегти
        </MyButton>
    </div>
  )
}

export default CreateNewSupplyOrderForm